import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// Components
import Tooltip from 'components/widgets/overlays/tooltip';
import AgreementLink from 'components/models/agreement/agreement-link';


export default function AgreementNickname({ agreement, className, noLink }) {
  if (!agreement || _.isEmpty(agreement)) return null;

  if (noLink) return <InnerNickname agreement={agreement} className={className} />;

  return (
    <AgreementLink agreement={agreement} className={className}>
      <InnerNickname agreement={agreement} />
    </AgreementLink>
  );
}

AgreementNickname.propTypes = {
  agreement: PropTypes.object,
  className: PropTypes.string,
  noLink: PropTypes.bool
};


// Inner Component
function InnerNickname({ agreement, className }) { // eslint-disable-line react/prop-types
  return (
    <Tooltip className={classNames('agreement-nickname', className)} title={agreement.title} elementType="span">
      {agreement.nickname}
    </Tooltip>
  );
}
